import * as Yup from 'yup'

export const ValidationSchema = () =>
	Yup.object().shape({
		grossSalary: Yup.number().required({ key: 'required' }).nullable(),
		staffUnitsCount: Yup.number().required({ key: 'required' }),
	})
